import React, { Fragment } from 'react';
import lodash from 'lodash';
import './styles.scss';
import Pagination from '../../../components/pagination';
import Table from '../../../components/table';
import Button from '../../../components/button';
import AddWorkSpace from './delivery-add-workspace';
// import DeleteTopic from './delivery-delete';
import GetTopics from './delivery-get-topic';
import Fuse from 'fuse.js';

import {
    ACTIONS,
    getAdminDelivery,
    getTopicWorkSpace,
    getFilesWorkSpaceAdmin,
    getFilesIdWorkSpaceAdmin,
    deleteFilesIdWorkSpaceAdmin,
    postFilesWorkSpaceAdmin,
    copyWorkSpace,
    deleteTopics,
    deleteWorkSpace, openTopics, getListCustomers, editWorkSpace
} from './../../../actions/admin-delivery';

import { connect } from 'react-redux';
import DebounceInput from 'react-debounce-input';
import Loading from '../../../components/loading';
import moment from 'moment';
import {TOPIC_GAME, TOPIC_PLAYER, TOPIC_TEAM} from '../my-topic'
import TopicChooseGame from '../my-topic/modal/TopicChooseGame';
import TopicChooseTeam from '../my-topic/modal/TopicChooseTeam';
import TopicChooseUser from '../my-topic/modal/TopicChooseUser';
import {createTopic} from "../../../actions/my-topic";
import ListTopic, {COPY_OTHER_WORKSPACE, DELETE, COPY_THIS_WORKSPACE} from './ListTopic';
import {getURLTopic} from "../../../actions/delivery";

let fuseInstance = {};

const fusionOptions = {
    keys : ['title'],
    tokenize: true,
    matchAllTokens: true,
    includeScore: true,
    includeMatches: true,
}

class AdminDelivery extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: null,
            selectedId: '',
            isShowDropdown: false,
            isClick: false,
            showToast: false,
            listDataDelivery: [],
            showLoading: false,
            listTopic: [],
            listFiles: [],
            selectedFileId: null,
            selectedFileName: null,
            file: null,
            idFirstGetTopic: 1,
            titleFirst: '',
            memo: '',
            lbCompany: '',
            lbGroup: '',
            lbUser: '',
            deliveryAt: '',
            updateAt: '',
            idTopicRemove: 1,
            arrCheck: [],
            cloneArrWorkspace: [],
            listCustomers: [],
            messageBlankCustomers: '',
            arrListSelected: [],
            listSuggest: [],
            updateBy: '',
            initPage: 1,
            totalpage: null,
            titleTopicRemove: '',
            idTopicSelected: null,
            modal: '',
            pageSize: null,
        }
    }

    getItemsPage(event) {
        this.setState({ showLoading: true, initPage: event });
        this.props.getAdminDelivery({ keyword: '', page: event });
    }

    changeShowDropdown(e) {
        this.setState({
            isShowDropdown: !this.state.isShowDropdown
        })
    }

    addData() {
        const wrapWorkspace = document.getElementById('wrap-workspace');
        wrapWorkspace.style.display = 'flex';
    }

    hideAddWorkspace() {
        const wrapWorkspace = document.getElementById('wrap-workspace');
        wrapWorkspace.style.display = 'none';
    }

    deleteWorkSpace() {
        const deleteTopic = document.getElementById('wrap-workspace-delete');
        deleteTopic.style.display = 'flex';
    }

    hideDelete() {
        const deleteTopic = document.getElementById('wrap-workspace-delete');
        deleteTopic.style.display = 'none';
    }

    actionButton = (key) => {
        switch (key) {
            case 'ゲームから追加':
                this.setState({modal: TOPIC_GAME});
                break;
            case '球団から追加':
                this.setState({modal: TOPIC_TEAM});
                break;
            case '選手から追加':
                this.setState({modal: TOPIC_PLAYER});
                break;
            default:
                return '';
        }
    }

    onCloseModal = () => {
        this.setState({modal: ''});
    };

    onCreateTopic = async (value) => {
        let params = { workspace_id: this.state.idFirstGetTopic };
        let url = '';

        if(this.state.modal === TOPIC_PLAYER) {
            params.player_id = value.id;
            url = `/player/${value.id}`;
        }
        if(this.state.modal === TOPIC_TEAM) {
            params.team_id = value.id;
            url = `/team-report/${value.id}`;
        }
        if(this.state.modal === TOPIC_GAME) {
            params.game_id = value.id;
            const date = moment(value.game_date, 'YYYY-MM-DD').format('YYYYMMDD');
            url = `/game/${value.id}/${value.home_team.id}/${date}`;
        }
        try {
            this.setState({showLoading: true});
            const {data} = await this.props.createTopic(params);
            this.setState({showLoading: false, modal: ''});
            this.props.getTopicWorkSpace(this.state.idFirstGetTopic);
            this.props.getFilesWorkSpaceAdmin(this.state.idFirstGetTopic);
            if(url) {
                this.props.history.push(url + `/topic/${data.id}`);
            }
        }catch (error) {
            this.setState({showLoading: false});
        }
    };

    onCopyMulti = (workspace) => {
        this.hideCopyTopic();
        this.setState({ showLoading: true });
        this.props.copyWorkSpace(this.state.idTopicSelected, workspace.id)
    }

    // activeLi = (e) => {
    //     const tabGame = document.querySelectorAll('.tab-game li');
    //     for (let i = 0; i < tabGame.length; i++) {
    //         tabGame[i].style.color = '#6E7F8A';
    //         tabGame[i].style.border = 'none';
    //     }
    //     e.target.style.color = '#3D3DF2';
    //     e.target.style.borderBottom = '4px solid #3D3DF2';
    // }


    hideDeleteMytopic() {
        const deleteTopic = document.getElementById('wrap-mytopic-delete');
        deleteTopic.style.display = 'none';
    }

    actionItemDropdownDot = (_i, k, item) => {
        if (k === 2) {
            const deleteTopic = document.getElementById('wrap-mytopic-delete');
            deleteTopic.style.display = 'flex';
            this.setState({ idTopicRemove: item.id, titleTopicRemove: item.title });
        } else if (k === 1) {
            this.setState({ idTopicSelected: item.id });
            const copyTopic = document.getElementById('wrap-copy-topic');
            copyTopic.style.display = 'flex';
        } else {
            this.setState({ showLoading: true });
            this.props.copyWorkSpace(item.id, this.state.idFirstGetTopic);
        }
    }

    hideCopyTopic() {
        const copyTopic = document.getElementById('wrap-copy-topic');
        copyTopic.style.display = 'none';
    }

    showDeliverySent = () => {
        let idWorkSpace = this.state.idFirstGetTopic;
        if (this.state.arrCheck.length) {
            let arr = this.state.listDataDelivery.map((val, i) => {
                if (val.id === idWorkSpace) {
                    val.deliveried_at = true;
                }
                return val;
            })
            this.setState({
                listDataDelivery: arr
            })

        }
        this.setState({ showToast: true }, () => {
            setTimeout(() => {
                this.setState({ showToast: false })
            }, 4400);
        });
        this.setState({ showLoading: true });
        const ids = [];
        this.state.listTopic.forEach((topic, index) => {
            const checked = this.state.arrCheck[index];
            if(!checked) return;
            ids.push(topic.id);
        });
        const data = {
            topic_ids: ids
        };
        const listDataDelivery = this.state.listDataDelivery;
        listDataDelivery.map((item) => {
            if(item.id === this.state.idFirstGetTopic) {
                return {
                    ...item,
                    title: this.state.titleFirst,
                }
            }
            return item;
        });
        this.setState({listDataDelivery});
        this.props.openTopics(data, this.state.idFirstGetTopic);
    }

    componentDidMount() {
        this.commonHideComponent('wrap-workspace', 'workspace');
        this.commonHideComponent('wrap-mytopic-delete', 'mytopic-delete');
        this.commonHideComponent('wrap-workspace-delete', 'workspace-delete');
        this.commonHideComponent('wrap-copy-topic', 'copy-topic');
        this.getAdminDelivery();
    }

    getAdminDelivery() {
        // this.setState({ showLoading: true })
        // const { search } = this.props.location;
        // const param = queryString.parse(search);
        // console.log(param);
        // if (!search) {
        //     this.props.history.push(`/admin-delivery?keyword=&page=1`);
        // } else {
        //     this.props.history.push(`/admin-delivery?keyword=${param.keyword}&page=${param.page}`);
        // }
        // const data = {
        //     keyword: param.keyword || '',
        //     page: param.page || 1
        // }
        // this.setState({ showLoading: true });
        this.props.getAdminDelivery({ page: 1, keyword: '' });
    }

    commonHideComponent(p, c) {
        const wrapWorkspace = document.getElementById(p);
        const workspace = document.getElementById(c);
        wrapWorkspace.addEventListener('click', function (event) {
            const isClickInside = workspace.contains(event.target);
            if (!isClickInside) {
                wrapWorkspace.style.display = 'none';
            }
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps) {
            if (nextProps.status === ACTIONS.GET_DATA_ADMIN_DELIVERY_SUCCESS) {
                const value = nextProps.response.data;
                const meta = nextProps.response.meta;
                if (value.length > 0) {
                    const listMapData = [...value[0].destinations_companies, ...value[0].destinations_groups, ...value[0].destinations_users];
                    fuseInstance = new Fuse(value, fusionOptions)
                    this.setState({
                        selectedId: value[0].id,
                        selectedIndex: 0,
                        listDataDelivery: value,
                        cloneArrWorkspace: value,
                        idFirstGetTopic: value[0].id,
                        titleFirst: value ? value[0].title : '',
                        memo: value[0].memo || '',
                        lbCompany: value[0].destinations_companies[0] ? value[0].destinations_companies[0].company.name : null,
                        lbGroup: value[0].destinations_groups[0] ? value[0].destinations_groups[0].group.name : null,
                        lbUser: value[0].destinations_users[0] ? value[0].destinations_users[0].user.name : null,
                        listSuggest: this.convertListDataUpdateWorkspace(listMapData),
                        deliveryAt: value[0].deliveried_at,
                        updateAt: moment(value[0].updated_at).format('YYYY/MM/DD HH:mm'),
                        showLoading: true,
                        updateBy: value[0].updated_by ? value[0].updated_by.name : '',
                        totalpage: meta.last_page,
                        pageSize: meta.per_page
                    }, () => {
                        this.props.getTopicWorkSpace(this.state.idFirstGetTopic);
                        this.props.getFilesWorkSpaceAdmin(this.state.idFirstGetTopic);
                    });
                } else {
                    this.setState({ showLoading: false, listDataDelivery: [], listTopic: [], listFiles: [] });
                }
            }
            if (nextProps.status === ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_SUCCESS) {
                const value = nextProps.response.data;
                const arrCheck = value.map(item => !!item.deliveried_at);
                this.setState({
                    listTopic: value,
                    showLoading: false,
                    arrCheck: arrCheck,
                })
            }
            if (nextProps.status === ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_SUCCESS) {
                const value = nextProps.response;
                this.setState({
                    listFiles: value,
                })
            }
            if (nextProps.status === ACTIONS.GET_DATA_ADMIN_DELIVERY_WORKSPACE_FILES_ID_SUCCESS) {
                const value = nextProps.response;
                this.setState({
                    file: value,
                })

                const blob = new Blob([value]);
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                document.body.appendChild(a);
                a.download = this.state.selectedFileName;
                a.href = url;
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            }
            if (nextProps.status === ACTIONS.ADD_ADMIN_DELIVERY_WORKSPACE_FILES_SUCCESS) {
                let list = this.state.listFiles;
                list.push(nextProps.response);
                this.setState({listFiles: list});
            }
            if (nextProps.status === ACTIONS.COPY_WORKSPACE_SUCCESS) {
                this.setState({ showLoading: false });
                this.props.getTopicWorkSpace(this.state.idFirstGetTopic);
            }
            if (nextProps.status === ACTIONS.DELETE_TOPICS_SUCCESS) {
                if (nextProps.response.message === 'success') {
                    setTimeout(() => {
                        this.setState({ showLoading: true }, () => {
                            document.getElementById('wrap-mytopic-delete').style.display = 'none';
                            this.props.getTopicWorkSpace(this.state.idFirstGetTopic);
                            // this.props.getAdminDelivery({ page: 1, keyword: '' });
                        });
                    }, 500);
                }
            }
            if (nextProps.status === ACTIONS.EDIT_WORKSPACE_SUCCESS) {
                if (nextProps.response.message === 'success') {
                    setTimeout(() => {
                        this.setState({ showLoading: true }, () => {
                            this.props.getTopicWorkSpace(this.state.idFirstGetTopic);
                            this.props.getAdminDelivery({ page: this.state.initPage, keyword: '' });
                            this.props.getFilesWorkSpaceAdmin(this.state.idFirstGetTopic);
                        });
                    }, 2000);
                }
            }
            if (nextProps.status === ACTIONS.OPEN_TOPIC_WORKSPACE_SUCCESS) {
                if (nextProps.response.message === 'success') {
                    this.setState({ showLoading: true }, () => {
                        this.props.getTopicWorkSpace(this.state.idFirstGetTopic);
                        this.props.getFilesWorkSpaceAdmin(this.state.idFirstGetTopic);
                    });
                }
            }
            if (nextProps.status === ACTIONS.GET_CUSTOMERS_SUCCESS) {
                const listCompany = this.convertTextData(nextProps.response ? nextProps.response.companies : [], 'companies');
                const listCompanyUser = this.convertTextData(nextProps.response ? nextProps.response.company_users : [], 'company_users');
                const group = this.convertTextData(nextProps.response ? nextProps.response.group : [], 'group');
                const users = this.convertTextData(nextProps.response ? nextProps.response.users : [], 'users');
                this.setState({
                    listCustomers: [...listCompany, ...listCompanyUser, ...group, ...users],
                    showLoading: false
                }, () => {
                    if (this.state.listCustomers.length === 0) {
                        this.setState({
                            messageBlankCustomers: 'Not match'
                        })
                    }
                });
            }
            if (nextProps.status === ACTIONS.DELETE_TOPICS_ERROR) {
                this.setState({
                    showLoading: true
                }, () => {
                    document.getElementById('wrap-workspace-delete').style.display = 'none';
                    // this.props.getAdminDelivery({ page: this.state.initPage, keyword: '' });
                });
            }
        }
    }

    convertListDataUpdateWorkspace = (list) => {
        if (list) {
            const listMap = list.map(value => {
                if (value.company) {
                    return { id: value.company.id, title: value.company.name, count: value.company.users_count, type: 'companies' };
                } else if (value.group) {
                    return { id: value.group.id, title: lodash.get(value, 'group.company.name', '') + '-' + value.group.name, count: value.group.users_count, company: value.group.company, type: 'group' };
                } else {
                    // value.user
                    return { id: value.user.id, title: lodash.get(value, 'user.company.name', '') + '-' + value.user.name, company: value.user.company, type: 'users' }
                }
            })
            return listMap;
        }
    }

    clickItemWorkSpace = (item, index) => {
        const listDataUpdate = [...item.destinations_companies, ...item.destinations_groups, ...item.destinations_users];
        this.setState({
            selectedIndex: index,
            selectedId: item.id,
            showLoading: true,
            titleFirst: item.title,
            memo: item.memo || '',
            lbCompany: item.destinations_companies[0] ? item.destinations_companies[0].company.name : '',
            lbGroup: item.destinations_groups[0] ? item.destinations_groups[0].group.name : '',
            lbUser: item.destinations_users[0] ? item.destinations_users[0].user.name : '',
            listSuggest: this.convertListDataUpdateWorkspace(listDataUpdate),
            deliveryAt: item.deliveried_at,
            updateAt: moment(item.updated_at).format('YYYY/MM/DD HH:mm'),
            idFirstGetTopic: item.id,
            updateBy: item.updated_by.name,
            arrCheck: []
        });
        this.props.getTopicWorkSpace(item.id);
        this.props.getFilesWorkSpaceAdmin(item.id);
    }

    convertListTopics = (list) => {
        if (list) {
            const listmap = list.map(value => {
                return {
                    item: [
                        { text: value.title, id: value.id, idWp: this.state.idFirstGetTopic },
                        { text: value.category_name },
                        {
                            text: this.handleTextCategory(value)
                        },
                        { text: moment(value.created_at).format('YYYY/MM/DD HH:mm') },
                        { text: moment(value.updated_at).format('YYYY/MM/DD HH:mm') },
                        { text: value.status ? value.status.name : '', dot: 'red' },
                        {
                            action: [
                                'このワークスペースにコピー', '他のワークスペースにコピー', '削除'
                            ]
                        }
                    ],
                    deliveried_at: value.deliveried_at,
                }
            })
            return listmap;
        }
    }

    handleTextCategory = (text) => {
        return `${text.game_date ? text.game_date : ''}
        ${text.away_team ? text.away_team.team_name : ''} - ${text.home_team ? text.home_team.team_name : ''}`
    }

    handleDeleteTopics = () => {
        this.setState({ showLoading: true });
        this.props.deleteTopics(this.state.idTopicRemove);
    }

    removeWorkSpace = async () => {
        const id = this.state.idFirstGetTopic;
        this.setState({ showLoading: true });
        await this.props.deleteWorkSpace(id);
        const listWorkSpace = this.state.listDataDelivery.filter(item => item.id !== id);
        const firstId = listWorkSpace.length > 0 ? listWorkSpace[0].id: null;
        this.setState({
            idFirstGetTopic: listWorkSpace.length > 0 ? listWorkSpace[0].id: null,
            showLoading: false
        });
        this.props.getAdminDelivery({ keyword: '', page: this.state.initPage });
        this.hideDelete();
    }

    doneAddWorkspace = () => {
        this.hideAddWorkspace();
        this.props.getAdminDelivery({ page: this.state.initPage, keyword: '' });
        this.clearSuggestion();
    }
    clearSuggestion = () => {
        const modal = document.getElementById('modal-customer');
        modal.style.display = 'none';
        const inputSearch = document.getElementById('input-search');
        inputSearch.value = "";
    }
    handleCheckItem = (index) => {
        const arrCheck = this.state.arrCheck;
        this.setState({
            arrCheck: arrCheck.map((value, idx) => {
                if(idx === index) {
                    return !value;
                }
                return value;
            })
        })
    }

    searchWorkspace = (ev) => {
        if (ev.target.value) {
            this.props.getAdminDelivery({ page: 1, keyword: ev.target.value });
        } else {
            this.props.getAdminDelivery({ page: 1, keyword: '' });
        }
    }

    getListCustomers = (event) => {
        if (event.key === "Enter" && event.target.value !== '') {
            const modal = document.getElementById('modal-customer');
            modal.style.display = 'block';
            this.setState({
                showLoading: true,
                messageBlankCustomers: ''
            });
            this.props.getListCustomers(event.target.value);
        }
    }

    convertTextData = (arr, text) => {
        if (arr) {

            if (text === 'companies') {
                return arr.map(key => {
                    return { id: key.id, title: key.name ? key.name : '', type: text }
                });
            } else {
                return arr.map(key => {
                    const title = key.company ? key.company.name : "";
                    return { id: key.id, title: title+ '-' + key.name, type: text }
                });
            }
        }
    }

    removeMessageBlank = (ev) => {
        if (!ev.target.value) {
            this.setState({
                messageBlankCustomers: '',
                // listCustomers: []
            });
        }
    }

    handleClickWorkSpace = (ev) => {
        const valueItem = [{ id: ev.id, title: ev.title, type: ev.type }];
        const mapData = [...this.state.listSuggest, ...valueItem];
        const data = this.checkUniqueItemArr(mapData);
        this.setState({
            listSuggest: data
        }, () => {
            const modal = document.getElementById('modal-customer');
            modal.style.display = 'none';
            const value = this.convertDataUpdate();
            this.props.editWorkSpace(this.state.idFirstGetTopic, value)
        });
    }

    checkUniqueItemArr = (arr) => {
        return [...new Map(arr.map(item => [item.id, item])).values()];
    }

    removeItemWorkspace = (id) => {
        this.setState({ showLoading: true });
        const arr = [];
        this.state.listSuggest.map((val) => {
            if (val.id !== id) {
                arr.push(val);
            }
            return true;
        });
        this.setState({ listSuggest: arr }, () => {
            const data = this.convertDataUpdate();
            this.props.editWorkSpace(this.state.idFirstGetTopic, data);
        });
    }

    downloadFileWorkspaceId = (idWorkSpace, id, fileName) => {
        this.setState({ 
            selectedFileId: id ,
            selectedFileName: fileName ,
        }, () => {
            this.props.getFilesIdWorkSpaceAdmin(idWorkSpace, id);
        });
    }

    deleteFileWorkspaceId = (idWorkSpace, id) => {
        this.props.deleteFilesIdWorkSpaceAdmin(idWorkSpace, id);
        let list = this.state.listFiles;
        list.some(function(v, i){
            if (v.id==id) list.splice(i, 1);
        });
        this.setState({listFiles: list});
    }

    uploadFileWorkspaceId = (idWorkSpace) => {
        this.props.postFilesWorkSpaceAdmin(idWorkSpace);
    }

    convertDataUpdate = () => {
        const data = this.convertTypeArrData(this.state.listSuggest);
        const convert = {
            title: this.state.listDataDelivery[this.state.selectedIndex].title || '',
            memo: this.state.listDataDelivery[this.state.selectedIndex].memo || '',
            destinations_company_ids: this.convertIdArr(data.companies) || [],
            destinations_group_ids: this.convertIdArr(data.group) || [],
            destinations_users: this.convertIdArr(data.users) || []
        };
        return convert;
    }

    convertTypeArrData = (arr) => {
        if (arr) {
            let ret = arr.reduce((acc, item) => ((acc[item['type']] = [...(acc[item['type']] || []), item]), acc), {});
            ret.users = [...ret.company_users || [] , ...ret.users || []];
            return ret;
        }
    }

    convertIdArr = (arr) => {
        if (arr) {
            return arr.map(x => x.id);
        } return []
    }

    changeInput = (ev, text) => {
        if (text === 'name' && ev.key === 'Enter') {
            this.setState({ showLoading: true, titleFirst: ev.target.value || '' }, () => {
                const data = this.convertDataUpdate();
                setTimeout(() => {
                    this.props.editWorkSpace(this.state.idFirstGetTopic, data);
                }, 2000);
            });
        }

        if (text === 'memo') {
            this.state.listDataDelivery[this.state.selectedIndex].memo = ev.target.value || '';
            this.setState({
                listDataDelivery: this.state.listDataDelivery,
                memo: ev.target.value || ''
            })
        }
    }

    updateWorkSpace = () => {
        const data = this.convertDataUpdate();
        this.props.editWorkSpace(this.state.idFirstGetTopic, {
            ...data,
            title: this.state.titleFirst,
        });
    }

    onColumnClick = (column, item) => {
        this.props.history.push(getURLTopic(item));
    };

    render() {
        return (
            <Fragment>
                <div id='admin-delivery' className="wrapper-content admin-delivery w-100 justify-content-start">
                    <div className="delivery w-42">
                        <div className="title d-inline-flex align-items-center font-weight-bold">
                            <h3>納品物</h3>
                            <div className="search position-relative">
                                <DebounceInput type="text" onChange={this.searchWorkspace} debounceTimeout={300} />
                                <img alt="search" src="/img/ic_search_svg.svg" className="position-absolute" />
                            </div>
                            <div className="add">
                                {/* <button className="btn">ワークスペースを追加</button> */}
                                <Button
                                    title={'ワークスペースを追加'}
                                    showIcon={true}
                                    isDropdown={false}
                                    addData={() => this.addData()}
                                />
                            </div>
                        </div>
                        <div className="delivery-table w-100 ">
                            <div className="table-wrapper">
                                <div className={'list-workspace'}>
                                    {
                                        this.state.listDataDelivery.length > 0 && this.state.listDataDelivery.map((value, index) => {
                                            const destinations = [...lodash.map(value.destinations_companies, 'company'), ...lodash.map(value.destinations_groups, 'group'), ...lodash.map(value.destinations_users, 'user')];
                                            const destination_dot = destinations.length > 1 ? '...' : '';
                                            const destination = destinations.length ? destinations[0].company ? destinations[0].company.name + '-'+ destinations[0].name : destinations[0].name : '' ;
                                            return (
                                                <div key={index} className='container-workspace'>
                                                    <div className="delevery-item-wrapper flex-column justify-content-between align-items-center   none-border ">
                                                        <div className="h-100 w-100 justify-content-between "
                                                            onClick={() => this.clickItemWorkSpace(value, index)}>
                                                            <div className="d-inline-flex justify-content-start align-items-center">
                                                                <div className="mr-1 info">
                                                                    <div className="">
                                                                        <h4 className="">{value.title}</h4>
                                                                        {value.topics_count > 0 && <div className="dsa-badge">{value.topics_count}</div>}
                                                                    </div>
                                                                    <div style={{display: 'flex', width: '100%', flexWrap: 'wrap'}}>
                                                                    {
                                                                        destination
                                                                            ? <>
                                                                            <div className={'tag-item'}>{destination}</div>
                                                                            <div>{destination_dot}</div>
                                                                            </>
                                                                        :null
                                                                    }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="date h-100 ">
                                                                <div className="d-inline-flex justify-content-end align-items-center">
                                                                    <div className="mr-1">更新日時：</div>
                                                                    <div>{moment(value.updated_at).format('YYYY/MM/DD HH:mm')}</div>
                                                                </div>
                                                                <div>
                                                                    {
                                                                        value.deliveried_at
                                                                            ? <button className="btn btn-secondary btn-sm d-block ml-auto">納品済</button>
                                                                            : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <Pagination onChangePage={(ev) => this.getItemsPage(ev)}
                                    items={this.state.listDataDelivery}
                                    initialPage={this.state.initPage}
                                    showPagination={true}
                                    pageSize={this.state.pageSize}
                                    totalPages={this.state.totalpage}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="wrap-work-space-admin">
                        <div className="work-space w-58">
                            <div className="title flex-row align-items-center justify-content-between ">
                                <div className="content align-middle">
                                    <input type='text' defaultValue={this.state.titleFirst}
                                           onKeyPress={(ev) => this.changeInput(ev, 'name')}
                                           onChange={(e) => this.setState({titleFirst: e.target.value})}
                                           onBlur={() => this.updateWorkSpace()} />
                                </div>
                                <div className="date flex-column align-items-flex-end justify-content-end">
                                    <div className="delivery-date flex-row justify-content-end align-items-center">
                                        <div className="mr-1">更新日時：</div>
                                        <div>{this.state.updateAt}</div>
                                    </div>
                                    <div className="last-update-date  flex-row justify-content-end align-items-center">
                                        <div className="mr-1">最終更新者：</div>
                                        <div>{this.state.updateBy}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="note-space w-100 p-2">
                                <textarea placeholder='メモ' value={this.state.memo || ''}
                                    onChange={(ev) => this.changeInput(ev, 'memo')} onBlur={() => this.updateWorkSpace()} />
                            </div>
                            <div className="wrapper-table table">
                                <div>
                                    <ListTopic
                                        hideDelete={!!this.state.deliveryAt}
                                        checkedValues={this.state.arrCheck}
                                        list={this.state.listTopic}
                                        onCheckboxChange={this.handleCheckItem}
                                        onChooseAction={(action, index, item) => this.actionItemDropdownDot(action, index, item)}
                                        onColumnClick={this.onColumnClick}
                                />
                                </div>
                                <div className="but-drop">
                                    <Button
                                        indexEvent={(i) => this.actionButton(i)}
                                        title={'Topicsを追加'}
                                        showIcon={true}
                                        isDropdown={true}
                                        itemDropdown={['ゲームから追加', '球団から追加', '選手から追加']} />
                                </div>
                            </div>
                        </div>
                        <div className="work-space-action-csv">
                            <div className=" justify-content-between">
                                <div>
                                    {this.state.listFiles ? 
                                        this.state.listFiles.map((item, index) => {
                                            return (
                                                <div>
                                                    <span>
                                                        <a key={index.toString()} onClick={() => this.downloadFileWorkspaceId(this.state.selectedId, item.id, item.file_name)}>
                                                            <span>{item.file_name}</span>
                                                        </a>
                                                    </span>
                                                    <span><img onClick={() => this.deleteFileWorkspaceId(this.state.selectedId, item.id)}
                                                        alt="delete" src="/img/navigation/cancel_24px.svg" /></span>
                                                </div>
                                            )
                                        }) : null}
                                </div>
                                <div className="export align-items-center">
                                    <label id="file_upload_label" for="file_upload"><img alt="draft" src="/img/ic_add_svg.svg" />アップロード
                                    <input type="file" id="file_upload" onChange={() => this.uploadFileWorkspaceId(this.state.selectedId)}></input></label>
                                </div>
                            </div>
                        </div>
                        <div className="work-space-action">
                            <div className="name-customer  align-items-center">
                                <label>宛先</label>
                                {this.state.listSuggest ?
                                    this.state.listSuggest.map((key, index) => {
                                        return (
                                            <div key={index.toString()}>
                                                <span>{key.title}</span>
                                                <img onClick={() => this.removeItemWorkspace(key.id)}
                                                    alt="delete" src="/img/navigation/cancel_24px.svg" />
                                            </div>
                                        )
                                    }) : null}
                            </div>
                            <div className="item-search-wp">
                                {
                                    this.state.messageBlankCustomers ?
                                        <p className="message">{this.state.messageBlankCustomers}</p> : null
                                }
                                {this.state.listCustomers ?
                                    <div id="modal-customer"
                                        className={this.state.listCustomers.length > 0 ? 'd-block search' : 'd-none search'}>
                                        {
                                            this.state.listCustomers.map((item, index) => {
                                                return (
                                                    <div key={index.toString()} className="item" onClick={() => this.handleClickWorkSpace(item)}>

                                                        {item.title}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div> : null}
                                <input type="text" id="input-search" placeholder="企業名、グループ名、もしくは、ユーザ名を入力してください" className="form-control rounded" onChange={this.removeMessageBlank}
                                    onKeyPress={this.getListCustomers} />
                            </div>
                            <div className=" justify-content-between">
                                {!this.state.deliveryAt ? <div className="delete  align-items-center" onClick={() => this.deleteWorkSpace()}>
                                    <img alt="draft" src="/img/ic_draft_svg.svg" />
                                    <span>ワークスペースを削除</span>
                                </div> : <div className="delete  align-items-center"></div>}
                                <div className="export  align-items-center">
                                    <label>{this.state.deliveryAt && moment(this.state.deliveryAt, 'YYYY-MM-DD HH:mm:ss').format('YYYY/MM/DD HH:mm') + "公開済"} </label>
                                    {
                                        Number(localStorage.getItem('MEMBER')) !== 3 ?
                                            <div onClick={() => this.showDeliverySent()}>
                                                <img alt='plan' src="/img/ic_plan_svg.svg" />
                                                <span>ワークスペースを公開</span>
                                            </div> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* add workspace */}
                <AddWorkSpace hide={this.hideAddWorkspace} doneAddWorkspace={this.doneAddWorkspace} />

                {/* delete topic */}
                {/* <DeleteTopic hide={this.hideDeleteMytopic} /> */}

                {/* copy topic other */}
                <GetTopics hide={this.hideCopyTopic} data={this.state.listDataDelivery}
                    onCopyMulti={id => this.onCopyMulti(id)} />

                {/* sent delivery */}
                {
                    this.state.showToast ? <div className="delivery-sent" >
                        <button id="btn-sent" >ワークスペースを公開しました</button>
                    </div> : null
                }

                {/* delete mytopic */}
                <div className="wrap-mytopic-delete" id="wrap-mytopic-delete">
                    <div className="mytopic-delete" id="mytopic-delete">
                        <h4>Topicsを削除</h4>
                        <p>このTopicsを削除します。本当によろしいですか？</p>
                        <div>
                            <div>
                                <label>タイトル : </label>
                                <span>{this.state.titleTopicRemove}</span>
                            </div>
                        </div>
                        <div>
                            <button onClick={() => this.hideDeleteMytopic()}>キャンセル</button>
                            <button type="button" onClick={this.handleDeleteTopics}>削除</button>
                        </div>
                    </div>
                </div>

                {/* delete popup 2 */}
                <div className="wrap-workspace-delete" id="wrap-workspace-delete">
                    <div className="workspace-delete" id="workspace-delete">
                        <h4>ワークスペースを削除</h4>
                        <p>このワークスペースを削除します。よろしいですか？</p>
                        <div>
                            <button onClick={this.hideDelete}>キャンセル</button>
                            <button onClick={this.removeWorkSpace}>削除</button>
                        </div>
                    </div>
                </div>

                {this.state.modal === TOPIC_GAME && <TopicChooseGame
                    onChange={this.onCreateTopic}
                    onClose={this.onCloseModal} />}

                {this.state.modal === TOPIC_TEAM && <TopicChooseTeam
                    onChange={this.onCreateTopic}
                    onClose={this.onCloseModal} />}

                {this.state.modal === TOPIC_PLAYER && <TopicChooseUser
                    onChange={this.onCreateTopic}
                    onClose={this.onCloseModal} />}

                {/* Loading */}
                <Loading show={this.state.showLoading} />
            </Fragment >
        )
    }
}

const mapStateToProps = ({ adminDelivery }) => {
    return {
        data: adminDelivery.data,
        header2: adminDelivery.header2,
        table: adminDelivery.table,
        response: adminDelivery.response,
        status: adminDelivery.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAdminDelivery: (data) => {
            dispatch(getAdminDelivery(data));
        },
        createTopic: (params) => dispatch(createTopic(params)),
        getTopicWorkSpace: (id) => {
            dispatch(getTopicWorkSpace(id))
        },
        getFilesWorkSpaceAdmin: (id) => {
            dispatch(getFilesWorkSpaceAdmin(id))
        },
        getFilesIdWorkSpaceAdmin: (idWorkSpace, id) => {
            dispatch(getFilesIdWorkSpaceAdmin(idWorkSpace, id))
        },
        deleteFilesIdWorkSpaceAdmin: (idWorkSpace, id) => {
            dispatch(deleteFilesIdWorkSpaceAdmin(idWorkSpace, id))
        },
        postFilesWorkSpaceAdmin: (idWorkSpace) => {
            dispatch(postFilesWorkSpaceAdmin(idWorkSpace))
        },
        copyWorkSpace: (idTopic, idWp) => {
            dispatch(copyWorkSpace(idTopic, idWp))
        },
        deleteWorkSpace: (id) => dispatch(deleteWorkSpace(id)),
        deleteTopics: (id) => {
            dispatch(deleteTopics(id))
        },
        openTopics: (idTopic, idWp) => {
            dispatch(openTopics(idTopic, idWp))
        },
        getListCustomers: (keyword) => {
            dispatch(getListCustomers(keyword))
        },
        editWorkSpace: (idWp, data) => {
            dispatch(editWorkSpace(idWp, data))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(AdminDelivery);
